const isProd = process.env.NODE_ENV === 'production';

var config = {
    "API_ENDPOINT":       isProd ? "https://demo-api.tracechain.io/" : "http://localhost:3000/",
    "API_Algo_ENDPOINT":  "http://13.86.24.106:5002/",
    "Local_ENDPOINT":     isProd ? "https://marketplace.tracechain.io/" : "http://localhost:8001/"
};

export default config;
